import {ChevronRight} from "react-feather";
import {Button} from "../common/Button";
import React from "react";
import {useNavigation} from "../navigation/useNavigation";
import {useAppTranslation} from "../app/appContext";
import {createUseStyles} from "react-jss";
import {useCurrentAnswer} from "../answer/useCurrentAnswer";
import {useView} from "../quiz/useView";
import {useQuizState, useQuizDispatch, ANSWER_REVEALED} from "../quiz/quizContext";
import {useCurrentQuestion} from "./useCurrentQuestion";

const useStyles = createUseStyles(() => ({
    nextButton: {
        display: "flex",
        padding: 4,
        cursor: "pointer",
    },
}))

export const NextButton = ({isMobile}) => {
    const t = useAppTranslation();
    const {
        navigateForward,
        lastQuestion
    } = useNavigation();

    const {finishQuiz} = useView();

    const {
        answerUniqueId
    } = useCurrentAnswer();

    const question = useCurrentQuestion();
    const quizState = useQuizState();
    const quizDispatch = useQuizDispatch();

    const immediateFeedback = quizState?.immediateFeedback ?? quizState?.quiz?.immediateFeedback ?? false;
    const isRevealed = Boolean(question?.answerRevealed);

    const classes = useStyles();

    const selectedAnswerId = question?.selectedAnswerUniqueId || answerUniqueId;

    if (!selectedAnswerId) {
        return null;
    }

    const isCheckMode = immediateFeedback && !isRevealed;

    const handleClick = () => {
        if (isCheckMode) {
            quizDispatch?.({
                type: ANSWER_REVEALED,
                questionUniqueId: question?.uniqueId
            });
        } else if (lastQuestion) {
            finishQuiz();
        } else {
            navigateForward();
        }
    };

    const getFullLabel = () => {
        if (isCheckMode) {
            return t("checkAnswerButton", "Sjekk svar");
        }
        if (lastQuestion) {
            return immediateFeedback
                ? t("seeResultButton", "Se resultat")
                : t("completeButton", "Fullfør");
        }
        return immediateFeedback
            ? t("nextQuestionButton", "Neste spørsmål")
            : t("nextButton", "Neste");
    };

    const fullLabel = getFullLabel();
    const visibleLabel = isMobile ? "" : fullLabel;

    return (
        <Button
            className={classes.nextButton}
            onClick={handleClick}
            Icon={<ChevronRight />}
            iconRight
            outline
            label={visibleLabel}
            ariaLabel={fullLabel}
            aria-label={fullLabel}
        />
    );
};
